import { Button, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TsrctDemandStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { useConfig } from '~/components/ConfigProvider';
import { NegotiationCaseCreateTrack } from '~/modules/NegotiationCaseCreateTrack/NegotiationCaseCreateTrack';

export interface DemandCaseAddProps {
  isActiveCompetitiveBidding?: boolean;
  isAwaitingRequestAnalysis?: boolean;
  negotiationCaseCount?: number;
  status?: TsrctDemandStatus;
}
const DISABLED_STATUS = [
  TsrctDemandStatus.COMPLETED,
  TsrctDemandStatus.CANCELLED,
  TsrctDemandStatus.PO_PENDING,
  TsrctDemandStatus.UPSTREAM_DELETED,
];

export const DemandCaseAdd = ({
  negotiationCaseCount,
  isActiveCompetitiveBidding,
  isAwaitingRequestAnalysis,
  status,
}: DemandCaseAddProps) => {
  const { demand } = useConfig();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(undefined, { keyPrefix: 'DemandAddSupplierDialog' });
  const { t: tCommon } = useTranslation(I18nNamespace.common, { keyPrefix: 'CompetitiveBidding' });

  const demandIsCompleted = status && DISABLED_STATUS.includes(status);

  const casesLimitReached = demand.parallelNegotiationsMax
    ? (negotiationCaseCount || 0) >= demand.parallelNegotiationsMax
    : false;

  let tooltip = '';

  if (casesLimitReached) {
    tooltip = t('button.disabledByLimit');
  }

  if (isAwaitingRequestAnalysis) {
    tooltip = t('button.disabledByDemandStatus');
  }

  if (demandIsCompleted) {
    tooltip = t('button.disabledByDemandStatus');
  }

  if (isActiveCompetitiveBidding) {
    tooltip = tCommon('addCase');
  }

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const disabled = demandIsCompleted || casesLimitReached || isAwaitingRequestAnalysis || isActiveCompetitiveBidding;

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <Button disabled={disabled} variant="contained" color="primary" onClick={() => setOpen(true)}>
            {t('button.cta')}
          </Button>
        </span>
      </Tooltip>
      <NegotiationCaseCreateTrack onClose={closeDialog} negotiationCaseCount={negotiationCaseCount} open={open} />
    </>
  );
};
